import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { Routes } from '../../routes';

import { Leaderboard } from './components/Leaderboard';
import LeaderboardTable from './components/LeaderboardTable';
import TeamLeagueWeeks from './components/TeamLeagueWeeks';
import { useStats } from './StatsContext';
import styles from './styles.module.scss';

export const GroupStage = () => {
  const { parsedWeeks } = useStats();

  return (
    <>
      <section>
        <header className={styles.headerSimple}>
          <h1 className={clsx(styles.stageHeading)}>Základní část</h1>
        </header>
        <section className={styles.content}>
          <h2 className="visually-hidden">Aktuální pořadí</h2>
          <div className={styles.leaderboard}>
            <Leaderboard />
            <LeaderboardTable />
          </div>
        </section>
        <section className={clsx(styles.content, styles.space)}>
          <TeamLeagueWeeks weeks={parsedWeeks} />
        </section>
      </section>
      <nav className={clsx(styles.buttonList, styles.navBottom)}>
        <Link to={Routes.TL25.routes.PLAYOFF.path} className={styles.navButton}>
          Play-off
        </Link>
        <Link to={Routes.TL25.routes.OVERVIEW.path} className={styles.navButton}>
          Přehled
        </Link>
      </nav>
    </>
  );
};
